import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';
import DownloadReports from './DownloadReports.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

const reportMeta = (...keys) => ({
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage', ...keys],
});

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta: reportMeta('report_agents'),
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta: reportMeta('report_inboxes'),
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta: reportMeta('report_labels'),
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta: reportMeta('report_teams'),
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: reportMeta('report_agents'),
    component: AgentReportsIndex,
  },
  {
    path: 'me',
    name: 'own_agent_reports',
    meta: reportMeta('report_own'),
    redirect: to => ({
      name: 'profile_reports',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: reportMeta('report_own', 'report_agents'),
    component: AgentReportsShow,
  },
  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: reportMeta('report_inboxes'),
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: reportMeta('report_inboxes'),
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: reportMeta('report_teams'),
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: reportMeta('report_teams'),
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: reportMeta('report_labels'),
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: reportMeta('report_labels'),
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: reportMeta('report_overview'),
          component: LiveReports,
        },
        {
          path: 'download',
          name: 'account_download_reports',
          meta: reportMeta('report_overview'),
          component: DownloadReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: reportMeta('report_conversation'),
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta: reportMeta('report_sla'),
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta: reportMeta('report_csat'),
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: reportMeta('report_bot'),
          component: BotReports,
        },
      ],
    },
  ],
};
